"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChromeStorageAsyncStore = void 0;
class ChromeStorageAsyncStore {
    constructor(storageArea, cooldownSeconds) {
        this.storageArea = storageArea;
        this.cooldownSeconds = cooldownSeconds;
        this.chromeStorageKey = 'eppo-configuration';
        this.metaKey = 'eppo-configuration-meta';
        this._isInitialized = false;
    }
    isInitialized() {
        return this._isInitialized;
    }
    async isExpired() {
        if (!this.cooldownSeconds) {
            return Promise.resolve(true);
        }
        const meta = await this.storageArea.get(this.metaKey);
        if (meta === null || meta === void 0 ? void 0 : meta[this.metaKey]) {
            const lastUpdatedAt = JSON.parse(meta[this.metaKey]).lastUpdatedAtMs;
            if (!lastUpdatedAt) {
                return Promise.resolve(true);
            }
            const now = Date.now();
            return Promise.resolve(now - lastUpdatedAt > this.cooldownSeconds * 1000);
        }
        return Promise.resolve(true);
    }
    async getEntries() {
        const configuration = await this.storageArea.get(this.chromeStorageKey);
        if (configuration === null || configuration === void 0 ? void 0 : configuration[this.chromeStorageKey]) {
            return Promise.resolve(JSON.parse(configuration[this.chromeStorageKey]));
        }
        return Promise.resolve({});
    }
    async setEntries(entries) {
        // chrome.storage.set takes a dictionary of key-value pairs,
        // so we need to pass it an object with a single property.
        // writes the entire configuration to a single location.
        await this.storageArea.set({
            [this.chromeStorageKey]: JSON.stringify(entries),
            [this.metaKey]: JSON.stringify({ lastUpdatedAtMs: new Date().getTime() }),
        });
        this._isInitialized = true;
        return Promise.resolve();
    }
}
exports.ChromeStorageAsyncStore = ChromeStorageAsyncStore;
//# sourceMappingURL=chrome.configuration-store.js.map